import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { ComponentProps } from 'react';

type DatagridNoRowsComponentProps = ComponentProps<typeof Stack> & {
    text?: React.ReactNode;
    "text-props"?: ComponentProps<typeof Typography>;
};

const DatagridNoRowsComponent = (props: DatagridNoRowsComponentProps) => {
    return (
        <Stack justifyContent={'center'} alignItems={'center'} height={'100%'} {...props}>
            <Typography {...props["text-props"]}>{props.text || 'No data to display'}</Typography>
        </Stack>
    );
};

export default DatagridNoRowsComponent;
